import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchWorkspaces } from '../../redux/Slices/workspaceSlice';
import { setLoading } from '../../redux/Slices/boardSlice';
import { closeExpandableColumn } from '../../redux/Slices/expandableColumnSlice';
import Spinner from '../Global/Spinner';
import Workspaces from '../icons/Workspaces';
import WorkspacePremium from '../icons/WorkspacePremium';
import Diamond from '../icons/Diamond';
import './WorkspacesColumn.scss';


const WorkspacesColumn = ({ workspaceId }) => {
    const dispatch = useDispatch();
    const { workspaces, status } = useSelector(state => state.workspaces);



    useEffect(() => {
        // Only fetch if we don't have workspaces and we're not currently loading
        if (workspaces.length < 1 && status !== 'loading') {
            dispatch(fetchWorkspaces({ useCache: true }));
        }
    }, [dispatch, workspaces.length, status]);

    const handleWorkspaceLink = () => {
        dispatch(setLoading(true));
        dispatch(closeExpandableColumn());
    }

    return (
        <div className='workspaces-column'>
            <div className="workspaces-column__content">
                {status === 'loading' ? (
                    <div className="loading-container">
                        <Spinner size={30} color="#3498db" speed={1.5} />
                    </div>
                ) : workspaces?.length > 0 ? (
                    <div className="workspaces-list">
                        {workspaces.map(workspace => (
                            <div
                                className={`workspace-item${workspaceId === workspace?.shortId ? ' active' : ''}`}
                                key={workspace._id}
                            >
                                <div className="workspace-avatar">
                                    <div className="workspace-icon">
                                        {workspace?.subscription ? (
                                            <>
                                                {workspace?.subscription?.planType === 'Premium' ? (
                                                    <WorkspacePremium
                                                        size={24}
                                                        color="var(--text-color)"
                                                    />
                                                ) : (
                                                    <Diamond
                                                        size={24}
                                                        color="var(--text-color)"
                                                    />
                                                )}
                                            </>
                                        ) : (
                                            <Workspaces
                                                size={24}
                                                color="var(--text-color)"
                                            />
                                        )}
                                    </div>
                                </div>

                                <div className="workspace-content">
                                    <div className="workspace-text">
                                        <strong>{workspace.name}</strong>
                                    </div>
                                    <div className="workspace-subtitle">
                                        {workspace?.subscription?.planType || 'Free'}
                                    </div>
                                </div>

                                {workspaceId !== workspace?.shortId && (
                                    <Link
                                        onClick={handleWorkspaceLink}
                                        className="workspace-link"
                                        to={`/w/${workspace.shortId}/boards`}
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="empty-state">
                        <div className="empty-icon">
                            🏢
                        </div>
                        <h3>No workspaces</h3>
                        <p>Create or join workspaces to see them here.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default WorkspacesColumn;
